import React, { useEffect } from "react";
import { MdOutlineWarning } from "react-icons/md";
import { FaIdCard } from "react-icons/fa";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import "./IdCardDialog.css";

const IdCardDialog = ({ isOpen, onContinue }) => {
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     console.log("[VIEWER] ID card dialog auto-closing after 10 seconds");
  //     onContinue();
  //   }, 10000);

  //   return () => clearTimeout(timer); // clean up timer on unmount
  // }, [onContinue]);

  if (!isOpen) return null;

  return (
    <div className="id-card-dialog-overlay">
      <div className="id-card-dialog">
        <div className="id-card-content">
          <div className="id-card-icon">
            <FaIdCard />
          </div>
          <h3>ID CARD VERIFICATION REQUIRED</h3>
          <div className="id-card-warning">
            <MdOutlineWarning />
            <span>IMPORTANT: Hold your ID card in front of the camera now</span>
          </div>
          <p>For identity verification, please follow these steps:</p>
          <ul>
            <li>
              <IoMdCheckmarkCircleOutline /> Position your ID card directly in
              front of the camera
            </li>
            <li>
              <IoMdCheckmarkCircleOutline /> Make sure all details are clearly
              visible
            </li>
            <li>
              <IoMdCheckmarkCircleOutline /> Ensure good lighting with no glare
              on the card
            </li>
            <li>
              <IoMdCheckmarkCircleOutline /> Hold the card steady until
              verification completes
            </li>
          </ul>
          <div className="id-card-note">
            <div className="progress-bar"></div>
            <p>This dialog will close automatically after 10 seconds</p>
            <p>Your ID card must be visible for verification to proceed</p>
          </div>
          <div className="id-card-actions">
            <button onClick={onContinue} className="id-card-btn">
              I've Positioned My ID Card
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdCardDialog;
